@if (nextButtonClicked) {
  <app-global-validation-message [formInput]="form"> </app-global-validation-message>
}
<form [formGroup]="form" class="form declarations">
  <ol class="questions">
    <li class="group">
      <fieldset>
        <ul class="choices">
          <li class="required" [ngClass]="{'invalid': isValidAcceptedDeclaration ? null: true }">
            <input type="checkbox" id="acceptedDeclaration" formControlName="acceptedDeclaration" />
            <label for="acceptedDeclaration">
              <p>In submitting this notification, I acknowledge that:</p>
              <ul>
                <li>The information I am supplying is true and correct</li>
                <li>I have read, understood and will comply with the requirements of the accepted development vegetation
                clearing code for the activity being notified</li>
                <li>The information I have provided will be used only in accordance with the Department of Natural Resources and Mines, Manufacturing and Regional and Rural Development
                  information privacy statement available at:
                  <a href="http://www.qld.gov.au/legal/privacy/">http://www.qld.gov.au/legal/privacy/</a>
                </li>
              </ul>
            </label>
            @if (!isValidAcceptedDeclaration && form.dirty) {
              <label>
                <em class="red-alert">You must indicate that you accept this acknowledgement</em>
              </label>
            }
          </li>
        </ul>
      </fieldset>
    </li>
  </ol>

  <br />
  <ul class="actions">
    <li> <input class="qg-btn btn-global-secondary" type="submit" (click)="previous()" value="Previous" /> </li>
    <li class="next primary"><em><input class="qg-btn btn-primary submit-button" type="submit"
    (click)="next()" value="Submit Notification" /> </em> </li>
  </ul>
  <ul class="actions">
    <li>
      <a href (click)="cancel()">Cancel</a>
    </li>
  </ul>
</form>
